<template>
  <el-container>
    <el-container>
      <el-aside width="200px">
        <el-header style="background-color: #303252; color: #fff; font-weight: bold; font-size: 22px"> 业高企业管理 </el-header>
        <el-menu :default-active="menuActive" background-color="#303252" text-color="#fff" active-text-color="#ffd04b" router @select="handleSelect">
          <el-menu-item @click="setBreadcrumb()" index="/">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <div v-for="(item, index) in menu" :key="index">
            <el-menu-item @click="setBreadcrumb(item.name)" :index="item.route" v-if="!item.children">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
            <el-submenu :index="item.route" v-if="item.children">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item v-for="(subItem, subIndex) in item.children" :key="subIndex" @click="setBreadcrumb(item.name, subItem.name)" :index="subItem.route">{{ subItem.name }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </div>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header style="background-color: #ebf1f6">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 60px">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="(item, i) in breadcrumbList" :key="i">{{ item }}</el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="8">
              <el-dropdown trigger="click" style="float: right">
                <span class="el-dropdown-link"> {{ username }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="changePasswd">修改密码</el-dropdown-item>
                  <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
        <el-footer style="background-color: #ebf1f6">@2025 Admin</el-footer>
      </el-container>
    </el-container>
    <el-row>
      <el-dialog title="修改密码" :visible.sync="changePasswordShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
        <change-password ref="changePasswordRef" @callMethod="refresh"></change-password>
      </el-dialog>
    </el-row>
  </el-container>
</template>
<script>
import changePassword from '@/components/index/changePassword.vue';
export default {
  name: 'mainIndex',
  components: {
    changePassword
  },
  mounted() {
    this.$router.beforeEach((to, from, next) => {
      this.menuActive = to.path;
      this.breadcrumbList = JSON.parse(sessionStorage.getItem(this.menuActive));
      next();
    });
  },
  created() {
    this.menuActive = this.$route.path;
    this.breadcrumbList = JSON.parse(sessionStorage.getItem(this.menuActive));
    this.sysConfig();
  },
  provide() {
    return {
      reload: this.sysConfig
    };
  },
  data() {
    return {
      changePasswordShow: false,
      menuActive: '/',
      breadcrumbList: [],
      username: '',
      menu: []
    };
  },
  methods: {
    //退出登录
    async logout() {
      this.$message({
        message: '退出成功',
        type: 'success'
      });
      await this.$api.admin.logout();
      sessionStorage.removeItem('auth');
      localStorage.removeItem('auth');
      this.$router.push('/login');
    },
    async changePasswd() {
      this.changePasswordShow = true;
      this.$nextTick(() => {
        this.$refs.changePasswordRef.setData();
      });
    },
    async sysConfig() {
      await this.$api.admin.indexConfig().then(res => {
        if (res.code == 200) {
          this.menu = res.data.menu ? res.data.menu : [];
          this.username = res.data.username ?? '';
          this.$setPermMark(res.data.perm_mark);
        }
      });
    },
    refresh() {
      this.changePasswordShow = false;
    },
    //设置面包屑
    setBreadcrumb(title, title2) {
      if (title == undefined) {
        this.breadcrumbList = [];
      } else {
        this.breadcrumbList = [title];
      }
      if (title2 != undefined) {
        this.breadcrumbList.push(title2);
      }
    },
    handleSelect(key) {
      this.$nextTick(() => {
        sessionStorage.setItem(key, JSON.stringify(this.breadcrumbList));
      });
    }
  }
};
</script>
<style>
@import '../../assets/styles/global.css';

/* 引入公共CSS文件 */
html,
body,
#app,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #303252;
  color: #333;
  line-height: 200px;
}

.el-main {
  color: #333;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.el-menu {
  border-right: none;
}
</style>
